import {
    Box,
    Button,
    Link,
    Typography,
    Grid
} from '@mui/material'
import WithUs1 from '../../../assets/home/fn_withus1.png'
import WithUs2 from '../../../assets/home/fn_withus2.png'
import WithUs3 from '../../../assets/home/fn_withus3.png'
import React from 'react'
import { isTablet } from 'react-device-detect'
import { useTranslation } from 'react-i18next'

export const SMAppHomeFinancingWithUs: React.FC = () => {
    const { t } = useTranslation()

    const data = [
        {
            'title': t('t31'),
            'content':  t('t34'),
            'image': WithUs1,
            'link': '/motorcycle-financing',
        },
        {
            'title': t('t32'),
            'content':  t('t35'),
            'image': WithUs2,
            'link': '/personal-loan',
        },
        {
            'title': t('t33'),
            'content':  t('t36'),
            'image': WithUs3,
            'link': '/motor-vehicle',
        }
    ]

    // ======================= RENDER FUNCTIONS
    const renderPlan = (index: number) => {
        return (
            <Box key={index} sx={{
                paddingLeft: '12px',
                paddingRight: '12px'
            }}>
                <Box
                    sx={{
                        width: '100%',
                        paddingLeft: '16px',
                        paddingRight: '16px',
                        paddingBottom: '16px',
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundImage: `url(${data[index]['image']})`,
                        backgroundSize: 'contain',
                        backgroundPosition: isTablet ? 'center' : 'start',
                        backgroundRepeat: 'no-repeat',
                    }}
                >

                    <Box
                        sx={{
                            width: '100%',
                            flex: '1',
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: '205px',
                            paddingLeft: '24px',
                            paddingRight: '24px',
                            paddingBottom: '40px',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '10px',
                            boxShadow: '0px 10px 80px 3px #0000001A',
                        }}
                    >
                        <Typography fontSize={20} color={'#141F39'} textAlign={'left'} paddingTop={'40px'} fontWeight={600}>
                            {data[index]['title']}
                        </Typography>

                        <Typography fontSize={16} color={'#6B6B6B'} width={'100%'} textAlign={'left'} paddingTop={'8px'} fontWeight={400}>
                            {data[index]['content']}
                        </Typography>

                        <Link href={data[index]['link']} 
                        sx={{
                            paddingTop: '24px',
                            textDecoration: 'none'
                        }}>
                            <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                    borderRadius: '30px',
                                    height: 61,
                                    fontSize: 16,
                                    fontWeight: 500,
                                    bgcolor: '#FFC107',
                                    color: '#141F39',
                                    '&:hover': {
                                        bgcolor: '#FFC107',
                                    },
                                    textTransform: 'none',
                                }}
                            >
                                {t('t37')}
                            </Button>
                        </Link>
                    </Box>
                </Box>
            </Box>
        )
    }

    const renderPadPlan = (index: number) => {
        return (
           <Grid key={index} item xs={4}>
             <Box
                    sx={{
                        height: '100%',
                        width: '100%',
                        paddingLeft: '16px',
                        paddingRight: '16px',
                        paddingBottom: '16px',
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundImage: `url(${data[index]['image']})`,
                        backgroundSize: 'contain',
                        backgroundPosition: 'start',
                        backgroundRepeat: 'no-repeat',
                    }}
                >

                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            flexDirection: 'column',
                            marginTop: (window.innerWidth - 72)*0.02,
                            paddingLeft: '25px',
                            paddingRight: '24px',
                            paddingBottom: '40px',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '10px',
                            boxShadow: '0px 10px 80px 3px #0000001A',
                        }}
                    >
                        <Typography fontSize={20} color={'#141F39'} textAlign={'left'} paddingTop={'40px'} fontWeight={600}>
                            {data[index]['title']}
                        </Typography>

                        <Typography fontSize={16} color={'#6B6B6B'} width={'100%'} textAlign={'left'} paddingTop={'8px'} fontWeight={400}>
                            {data[index]['content']}
                        </Typography>

                        <Link href={data[index]['link']}  sx={{
                            paddingTop: '24px',
                            textDecoration: 'none',
                        }}>
                            <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                    borderRadius: '30px',
                                    height: 61,
                                    fontSize: 16,
                                    fontWeight: 500,
                                    bgcolor: '#FFC107',
                                    color: '#141F39',
                                    '&:hover': {
                                        bgcolor: '#FFC107',
                                    },
                                    textTransform: 'none',
                                }}
                            >
                                {t('t37')}
                            </Button>
                        </Link>
                    </Box>
                </Box>
           </Grid>
        )
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#FFFDF7',
        }}>
            <Typography fontSize={24} textAlign={'center'} paddingTop={'60px'} paddingBottom={'45px'} paddingLeft={'60px'} paddingRight={'60px'} fontWeight={700}>
                {t('t30')}
            </Typography>


            {isTablet ? (<Grid container alignItems={'stretch'} columnSpacing={2} paddingLeft={'12px'} paddingRight={'12px'}>{data.map((item, index) => renderPadPlan(index))}</Grid>) : (data.map((item, index) => renderPlan(index)))}
        </Box>
    )
}

// ======================= EXPORT
export default SMAppHomeFinancingWithUs
